export default "__VITE_ASSET__11b39ce4__"